import axios from "axios";
import { post, put, get, del } from '../api/axioshHttp'


// 请求标签列表
export const getpriseList = params => {
    return get("/admin/evaluate", params);
};
// 修改信息
export const editprise = params => {
    return put(`/admin/evaluate/${params.id}`, params);
};


// WEBPACK FOOTER //
// ./src/api/evaluate.js